import { GetStaticProps, NextPage } from "next";

import { BluetoothPageMetadata } from "@components/bluetooth-landing/BluetoothPageMetadata";
import { ClientToaster } from "@components/bluetooth-landing/ClientToaster";
import { darkGradient } from "@components/bluetooth-landing/ctaButtonStyles";
import { Footer } from "@components/bluetooth-landing/Footer";
import { Hero } from "@components/bluetooth-landing/Hero";
import { HubLinkList } from "@components/bluetooth-landing/HubLinkList";
import { Navbar } from "@components/bluetooth-landing/Navbar";
import * as copy from "@data/mvp-hub-landing/plCopy";

const MvpHubPage: NextPage = () => {
  return (
    <div className="bluetooth-landing">
      <BluetoothPageMetadata
        title={copy.title}
        description={copy.description}
        canonicalPath="/mvp"
        lang="pl"
        ogLocale="pl_PL"
        structuredData={copy.structuredData}
        alternatePaths={{
          pl: "/mvp",
          xDefault: "/mvp",
        }}
      />
      <ClientToaster />
      <Navbar copy={copy.navbarCopy} />
      <main>
        <Hero copy={copy.heroCopy} />

        <section id={copy.introCopy.id} className="py-24 bg-white">
          <div className="container mx-auto px-6 md:px-12 max-w-7xl">
            <div className="max-w-3xl">
              <h2
                className="text-sm font-semibold bg-clip-text text-transparent uppercase tracking-widest mb-3"
                style={{ backgroundImage: darkGradient }}
              >
                {copy.introCopy.eyebrow}
              </h2>
              <h3 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-6">
                {copy.introCopy.heading}
              </h3>
              {copy.introCopy.paragraphs.map(paragraph => (
                <p
                  key={paragraph}
                  className="text-lg text-slate-600 mb-4 last:mb-0"
                >
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </section>

        <HubLinkList copy={copy.servicesListCopy} />
        <HubLinkList copy={copy.blogListCopy} className="bg-white" />

        <section id={copy.processCopy.id} className="py-24 bg-background-light">
          <div className="container mx-auto px-6 md:px-12 max-w-7xl">
            <div className="max-w-3xl mb-12">
              <h2
                className="text-sm font-semibold bg-clip-text text-transparent uppercase tracking-widest mb-3"
                style={{ backgroundImage: darkGradient }}
              >
                {copy.processCopy.eyebrow}
              </h2>
              <h3 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-6">
                {copy.processCopy.heading}
              </h3>
            </div>
            <ol className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {copy.processCopy.steps.map((step, index) => (
                <li key={step.title}>
                  <p className="text-sm font-semibold text-slate-400 mb-2">
                    {String(index + 1).padStart(2, "0")}
                  </p>
                  <h4 className="text-xl font-semibold text-slate-900 mb-2">
                    {step.title}
                  </h4>
                  <p className="text-slate-600 leading-relaxed">
                    {step.description}
                  </p>
                </li>
              ))}
            </ol>
          </div>
        </section>
      </main>
      <Footer copy={copy.footerCopy} />
    </div>
  );
};

export const getStaticProps: GetStaticProps = async () => ({
  props: {},
});

export default MvpHubPage;
